import { render, staticRenderFns } from "./ClientEditModal.vue?vue&type=template&id=54e885d6&scoped=true&"
import script from "./ClientEditModal.vue?vue&type=script&lang=js&"
export * from "./ClientEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e885d6",
  null
  
)

export default component.exports